import React from 'react'
import { word } from "../../word.js";
import makeAnimated from "react-select/animated";
import Account from "../../helpers/Account.js";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
const { profession } = Account.getData()
import Select from "react-select";

export default function EventDropTask({ forMe, options, setFormData, setForMe, item }) {
    const animatedComponents = makeAnimated();
    const handleSelectChange = (ev) => {
        setFormData((prevForm) => ({ ...prevForm, [item.key]: ev })
        );
    }
    
    return (
        <div

            className={"input-validation"}
        >
            {item.key === "accountant" ? (
                <Select
                    isDisabled={forMe}
                    closeMenuOnSelect={false}
                    value={item.value}
                    components={animatedComponents}
                    options={options}
                    onChange={handleSelectChange}
                    placeholder={word[item.key]}
                    isMulti
                />
            ) : (
                <Autocomplete
                    loading={options.length === 0}
                    options={options}
                    value={options.find(opt => opt.url === item.value) || null}
                    onChange={(e, value) => {
                        setFormData((prevForm) => ({ ...prevForm, [item.key]: value?.url })
                        );
                        if (item.key === "manager" && value && profession === "manager") {
                            setForMe(true);
                        } else if (item.key === "manager" && !value) {
                            setForMe(false);
                        }
                    }}
                    getOptionLabel={(option) =>
                        item.key === "manager" ? `${option.user.first_name} ${option.user.last_name}` : option.name
                    }
                    getOptionKey={(option) => option.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={word[item.key]}
                            variant="outlined"
                            fullWidth
                        />
                    )}
                />
            )}
            {/* {!item.valid && submitted && <div className="validation valid-center">{word[item.errorMessage]}</div>} */}
        </div>
    )
}
